import React from "react";
import PropTypes from 'prop-types';

import RenderComponentProto from "../../render-component-proto";

import InputInlineEditable from 'core/gd-components/input-inline-editable/input-inline-editable';

export default class PhoneField extends RenderComponentProto {

    static props = {
        id: PropTypes.string.isRequired,
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value: PropTypes.any,
        canEdit: PropTypes.bool,
        onChange: PropTypes.func,
        //old
        params: PropTypes.object,
        onFocusCallback: PropTypes.func,
        onBlurCallback: PropTypes.func,
        stateless: PropTypes.bool // ????
    };

    static defaultProps = {
        canEdit: false
    };

    state = {
        isEditing: false,
        value: this.props.value
    }

    onChange = (newValue) => {
        if (!newValue) newValue = '';

        this.setState({value: newValue}, ()=>{
            if (this.props.onChange) this.props.onChange(newValue)
        });
    }

    onFocus = (e) => {
        this.setState({isEditing: true}, ()=> {
            if (this.props.onFocus) this.props.onFocus(e)
        });
    }

    onBlur = (e) => {
        this.setState({isEditing: false}, ()=>{
            if (this.props.onBlur) this.props.onBlur(e);
        });
    }

    onCopyClick = () => {
        this.phone.select();
        document.execCommand('copy');
        gd.growl.success('Phone number copied to clipboard.')
    }

    render() {
        const classes = Classes('gd-field-phone gd-custom-field-input-based',this.props.renderMode,{
            'edit': this.state.isEditing,
            'disabled': this.props.canEdit === false,
            'not-set': !this.state.value
        });

        const borderComponent = this.state.value && this.props.renderMode === 'list' && !this.state.isEditing ? <div className="value-border">{this.state.value}</div> : null

        return (
            <div className={classes}>
                <InputInlineEditable ref={r=>this.phone = r}
                                     value={this.state.value}
                                     disabled={(this.props.canEdit === false)}
                                     onChange={this.onChange}
                                     onFocus={this.onFocus}
                                     onBlur={this.onBlur}
                                     commitDelay={2000}/>
                <div className="i5-phone"/>
                <div className="btn-copy i5-clone" onClick={this.onCopyClick}/>
                {borderComponent}
            </div>

        );
    }
}